module.exports = __webpack_public_path__ + "static/media/mini.6fc463ca.png";